var chunkToChildrenMap = {
	"445": [
		96,
		348,
		665,
		394,
		148,
		212
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, function() {

}); };